import { default as TopicSidebar } from './TopicSidebarContainer';

export default TopicSidebar;
